import React, { Component } from "react";
import PageContent from "@my-dld/components/PageContent";
import Strings from "@my-dld/assets/strings";
import { PSRole, PvtSellRequest } from "../../../apis/privatesell/enitites";
import { getProcedureNumber } from "./AcceptRequestSuccess";
import { extractPropInfo } from "../../MyDLD/PropertyDetails";

interface Props {
	children?: any;
	titleExtra?: any;
	role: PSRole;
	request: PvtSellRequest;
}

export default class PrivateSellHeader extends Component<Props> {
	constructor( props: Props ) {
		super( props );
	}

	render() {
		const { children, role, request, titleExtra } = this.props;
		const roleHeading = role === PSRole.SELLER ? Strings.sell_property : Strings.gl_buy_property;
		const heading = ( request.bookingRequestInfo ) ? Strings.booking_ref_number + " : " + request.bookingRequestInfo.referenceNumber : "";
		const procedure = ( request ) ? getProcedureNumber( request.bookingRequestInfo ) : undefined;
		const headerProcedure = ( procedure ) ? " & " + Strings.procedure_number + " : " + procedure : "";
		const property = ( request.propertyInfo &&
			request.propertyInfo.propertyObject ) ? JSON.parse( request.propertyInfo.propertyObject ) : undefined;
		let title = `${ roleHeading } (${ heading }${ headerProcedure })`;
		if ( property ) {
			const { val, lbl } = extractPropInfo( property );
			title = `${ title } - ${ lbl } : ${ val }`;
		}
		return <PageContent
			title={ title } titleExtra={ titleExtra }
			hideQLinks={ true }>
			{ children }
		</PageContent>;
	}
}
